module.exports = __webpack_public_path__ + "img/reference-break-media.ce708e99.jpg";